module.exports = __webpack_public_path__ + "static/media/signage-indoor-img81.3e796ac5.jpg";